const mutations = {
  ["SET_USERS"](state, payload) {
    state.AllUsers = payload;
  },
  ["SET_USER"](state, payload) {
    state.User = payload;
  },
  ["UPDATE_USER"](state, payload) {
    state.User = payload;
  },
  ["DELETE_USER"](state, payload) {
    state.User = payload;
  },
  ["REGISTER_USER"](state, payload) {
    state.NewUser = payload;
  },
  ["RESET_PASSWORD"](state, payload) {
    state.Password = payload;
  }
};

export default mutations;
